import React , {useState,useEffect} from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useParams } from 'react-router-dom';
import HoursOfOperationForm from './HoursOfOperationForm';
import {toast} from 'react-toastify'

const HoursOfOperation = () => {
    const [clinic, setClinic] = useState({});
    const [loading, setLoading] = useState(true);
    const {clinicId} = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const [hours , setHours] = useState();
    useEffect(() => {
        setLoading(true);
        clinicService.getHours(clinicId)
            .then(hours => {
                setHours(hours.data);
               // console.log(hours);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                toast.error("Error While getting Hours",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            });
    }, [clinicId]);
    const updateHours = (hours)=>{
        setHours(hours)
    }
    return ( 
        <>
            <div className="d-flex justify-content-between">
                    <h5 className="card-title" style={{color:"#012970"}}> Hours of operations</h5>
                    <div>
                        {isEditing ?
                            <button className="btn btn-secondary btn-sm mt-2" onClick={() => setIsEditing(false)}>
                               <i className="bi bi-x-square bi-sm"></i> Cancel</button>
                            :
                            <button className="btn btn-secondary btn-sm mt-2" onClick={() => setIsEditing(true)}>
                               <i className="bi bi-pencil-square bi-sm"></i> Edit</button>
                        }
                            </div>
            </div>
            {loading ?  <p>Loading...</p> :
                isEditing ? <HoursOfOperationForm hof={hours} updateHours = {updateHours} /> :
            <div>
            <table className='table table-striped table-hover table-bordered'>
                <thead>
                    <tr>
                        <th scope='col'> 
                                Days
                        </th>
                        <th scope='col'>
                             Hours
                        </th>
                        <th scope='col'>
                            Status
                        </th>
                        <th scope='col'>
                            Notes
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {hours.map(hour =>(
                            <tr key={hour.id} className={hour.status? "":"table-danger"} >
                                <td>{hour.day}</td>
                                <td>{hour.start} - {hour.end}</td>
                                <td>{hour.status? "Open":"Closed"}</td>
                                <td>{hour.note}</td>
                            </tr>
                    ))}
                   
                </tbody>
            </table>
           
            </div>
            }
        </>
     );
}
 
export default HoursOfOperation;